import React, { useState } from 'react';

const ContactFormWidget = () => {
  const [formData, setFormData] = useState({
      to: "",
      subject: "",
      name: "",
      html: "",
    });
  
    const [loading, SetLoading] = useState(false);
  
    // Handle input changes
    const handleChange = (e) => {
      const { name, value } = e.target;
      setFormData((prevState) => ({ ...prevState, [name]: value }));
    };
  
    // Handle form submission
    const handleSubmit = async (e) => {
      e.preventDefault();
      if (loading) {
        return;
      }
      try {
        SetLoading(true);
        // Make a POST request with raw JSON data
        const response = await fetch("https://api.harsafe.com/send-email", {
          method: "POST",
          headers: {
            "Content-Type": "application/json", // Specify JSON content type
          },
          body: JSON.stringify(formData), // Send form data as raw JSON
        });
  
        const result = await response.json();
  
        if (response.ok) {
          setFormData({
            to: "",
            subject: "",
            name: "",
            html: "",
          });
          alert("Email sent successfully!");
        } else {
          alert(`Failed to send email: ${result.message || "Error"}`);
        }
        SetLoading(false);
      } catch (error) {
        SetLoading(false);
        console.error("Error:", error);
        alert("An error occurred while sending the email.");
      }
    };


  return (
    <form onSubmit={handleSubmit}>
      <div className="row">
        <div className="col-sm-6">
          <div className="single-form">
            <input
              type="text"
              placeholder="Name *"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>
        </div>
        <div className="col-sm-6">
          <div className="single-form">
            <input
              type="email"
              placeholder="Email *"
              name="to"
              value={formData.to}
              onChange={handleChange}
              required
            />
          </div>
        </div>
        <div className="col-sm-12">
          <div className="single-form">
            <input
              type="text"
              name="subject"
              value={formData.subject}
              onChange={handleChange}
              placeholder="Subject *"
              required
            />
          </div>
        </div>
        <div className="col-sm-12">
          <div className="single-form">
            <textarea
              name="html"
              placeholder="Write A Message"
              value={formData.html}
              onChange={handleChange}
            ></textarea>
          </div>
        </div>
        <div className="col-sm-12">
          <div className="form-btn">
            {/* <button className="btn" type="submit">
              {loading ? 'Sending...' : 'Send Message'}
            </button> */}

<button className="btn" type="submit" disabled={loading}>
              {loading ? (
                <div className="spinner">
                  <span className="loader"></span> Sending...
                </div>
              ) : (
                "Send Message"
              )}
            </button>
          </div>
        </div>
      </div>
    </form>
  );
};

export default ContactFormWidget;
